import gql from 'graphql-tag';

export const GET_ADMIN = gql`
  query(
    $user_id: ID!
  ) {
    GetAdmin(
      user_id: $user_id
    ) {
      user_name
      family_name
      given_name
      password
      display_password
      golf_code
      golf_name
      user_div
      code
      code_name
      email
    }
  }
`;

export const GET_ADMIN_MEMBER_LIST = gql`

    query (
      $full_name: String
      $golf_code: String
      $begin_row: Int
      $limit_rows: Int
      ) {
        GetAdminMemberList (
          full_name: $full_name
          golf_code: $golf_code
          begin_row: $begin_row
          limit_rows: $limit_rows
        ) {
          AdminMemberList{
            user_id
            user_name
            family_name
            given_name
            password
            user_div
            golf_name
            code
            code_name
            email
          }
          count
        }
    },
`;

export const REGISTER_ADMIN = gql`
    mutation (
        $user_name:       String!
        $family_name:     String!
        $given_name:      String!
        $password:        String!
        $golf_group_code: String!
        $golf_code:       String!
        $user_div:        String!
        $email:           String!
      ) {
        RegisterAdmin(
          user_name: $user_name
          family_name: $family_name
          given_name: $given_name
          password:  $password
          golf_group_code: $golf_group_code
          golf_code: $golf_code
          user_div:  $user_div
          email: $email
        ) {
          result
      }
    }
`;

export const UPDATE_ADMIN = gql`
    mutation (
        $user_id:         ID!
        $user_name:       String!
        $save_user_name:  String
        $family_name:     String!
        $given_name:      String!
        $password:        String
        $golf_group_code: String!
        $golf_code:       String!
        $user_div:        String!
        $email:           String
      ) {
        UpdateAdmin(
          user_id:   $user_id
          user_name: $user_name
          save_user_name: $save_user_name
          family_name: $family_name
          given_name: $given_name
          password:  $password
          golf_group_code: $golf_group_code
          golf_code: $golf_code
          user_div:  $user_div
          email: $email
        ) {
          result
      }
    }
`;

export const DELETE_ADMIN = gql`
mutation (
      $user_id: ID!
    ) {
      DeleteAdmin(
        user_id: $user_id
      ){
        result
      }
    }
`;

export const GET_GOLF_COURSE_LIST = gql`
    query( $golf_group_code: String! ){
    golfCourseListByAdminList(golf_group_code: $golf_group_code) {
            golf_code
            golf_name
        }
    }
`;
